import * as _types from "../_constants/types";
import ws from "../_constants/webservices";

export const setLanguage = language => dispatch => {
    dispatch({
        type: _types.LANGUAGE_LOAD,
        results: language
    });
};

export const setStore = store => dispatch => {
    dispatch({
        type: _types.STORE_LOAD,
        results: store
    });
};

export const setCountry = country => dispatch => {
    dispatch({
        type: _types.COUNTRY_LOAD,
        results: country
    });
};

export const resetLanguage = () => dispatch => {
    dispatch({
        type: _types.LANGUAGE_RESET
    });
};

export const resetStore = () => dispatch => {
    dispatch({
        type: _types.STORE_RESET
    });
};

export const resetCountry = () => dispatch => {
    dispatch({
        type: _types.COUNTRY_RESET
    });
};

export const getLanguages = () => dispatch => {
    dispatch({ type: _types.LANGUAGE_LIST_RESET });
    dispatch({ type: _types.LANGUAGE_LIST_FETCHING });

    let url = `/public/dimensions/languages`;

    ws.shopify
        .get(url)
        .then(({ json, response }) => {
            dispatch({
                type: _types.LANGUAGE_LIST_LOAD,
                results: json
            });
            dispatch({
                type: _types.LANGUAGE_LIST_FETCHING_COMPLETED
            });
        })
        .catch((err, response) => {
            dispatch({
                type: _types.LANGUAGE_LIST_FETCHING_FAILED,
                err: err
            });
        });
};

export const getStores = () => dispatch => {
    dispatch({ type: _types.STORE_LIST_RESET });
    dispatch({ type: _types.STORE_LIST_FETCHING });

    let url = `/public/dimensions/stores`;

    ws.shopify
        .get(url)
        .then(({ json, response }) => {
            dispatch({
                type: _types.STORE_LIST_LOAD,
                results: json
            });
            dispatch({
                type: _types.STORE_LIST_FETCHING_COMPLETED
            });
        })
        .catch((err, response) => {
            dispatch({
                type: _types.STORE_LIST_FETCHING_FAILED,
                err: err
            });
        });
};

export const getCountries = () => dispatch => {
    dispatch({ type: _types.COUNTRY_LIST_RESET });
    dispatch({ type: _types.COUNTRY_LIST_FETCHING });

    let url = `/public/dimensions/countries`;

    ws.shopify
        .get(url)
        .then(({ json, response }) => {
            dispatch({
                type: _types.COUNTRY_LIST_LOAD,
                results: json
            });
            dispatch({
                type: _types.COUNTRY_LIST_FETCHING_COMPLETED
            });
        })
        .catch((err, response) => {
            dispatch({
                type: _types.COUNTRY_LIST_FETCHING_FAILED,
                err: err
            });
        });
};

export const getCancelReasons = () => dispatch => {
    dispatch({ type: _types.CANCEL_REASON_LIST_FETCHING });

    let url = "/public/dimensions/cancel-reasons";

    ws.shopify
        .get(url)
        .then(({ json, response }) => {
            if (response.status === 200) {
                dispatch({ type: _types.CANCEL_REASON_LIST_LOAD, data: json });
            }
            dispatch({ type: _types.CANCEL_REASON_LIST_FETCHING_COMPLETED });
        })
        .catch(err => {
            dispatch({ type: _types.CANCEL_REASON_LIST_FETCHING_FAILED, err: "failed" });
        });
};

export const resetCancelReasons = () => dispatch => {
    dispatch({ type: _types.CANCEL_REASON_LIST_RESET });
};

export const getReturnReasons = () => dispatch => {
    dispatch({ type: _types.RETURN_REASON_LIST_FETCHING });

    let url = "/public/dimensions/return-reasons";

    ws.shopify
        .get(url)
        .then(({ json, response }) => {
            if (response.status === 200) {
                dispatch({ type: _types.RETURN_REASON_LIST_LOAD, data: json });
            }
            dispatch({ type: _types.RETURN_REASON_LIST_FETCHING_COMPLETED });
        })
        .catch(err => {
            dispatch({ type: _types.RETURN_REASON_LIST_FETCHING_FAILED, err: "failed" });
        });
};

export const resetReturnReasons = () => dispatch => {
    dispatch({ type: _types.RETURN_REASON_LIST_RESET });
};
